/**
 * Registry of interstitial components that can be displayed between PDF pages.
 *
 * To add a new interstitial type:
 * 1. Create your component in the interstitials/ directory
 * 2. Add the component to this registry with a unique key
 * 3. Add the type definition to interstitials/types.ts
 * 4. Use the component key in InterstitialConfig when passing to Attachment component
 *
 * Example:
 * // In interstitials/UpgradePrompt.tsx
 * export const UpgradePrompt: React.FC = () => { ... };
 *
 * // In this file
 * import { UpgradePrompt } from './interstitials/UpgradePrompt';
 * export const InterstitialRegistry = {
 *   'upgrade-prompt': UpgradePrompt,
 * } as const;
 *
 * // In interstitials/types.ts
 * export type UpgradePromptInterstitial = {
 *   afterPage: number;
 *   componentKey: 'upgrade-prompt';
 *   key: string;
 * };
 */
import { SignupBanner } from './interstitials/SignupBanner';
import { RelatedPapers } from './interstitials/RelatedPapers';

export const InterstitialRegistry = {
  'signup-banner': SignupBanner,
  'related-papers': RelatedPapers,
} as const;

export type InterstitialKey = keyof typeof InterstitialRegistry;
